import React from 'react';
import { Row } from 'react-table';
import classNames from 'classnames';

import { CheckboxRadioInput } from '../../checkbox-radio-input';

interface RowSelectCheckboxProps {
  row: Row<object>;
  isRowSelectable: (row: Row<object>) => boolean;
}

export const RowSelectCheckbox: React.FC<RowSelectCheckboxProps> = ({
  row,
  isRowSelectable,
}) => {
  const disabled = !isRowSelectable(row);
  return (
    <CheckboxRadioInput
      disabled={disabled}
      className={classNames(
        disabled ? 'cursor-auto' : 'cursor-pointer',
        'block'
      )}
      {...row.getToggleRowSelectedProps()}
    />
  );
};
